export const desktopBreakpoint = 601;
export const sidebarBreakpoint = 960;
export const mqTablet = '@media (min-width: 600px) and (max-width: 801px)';
export const mqFromDesktop = '@media (min-width: 601px)';
export const mqFromDesktopHD = '@media (min-width: 1920px)';
